import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'antd';
import yeastIcon from 'assets/micro-required-yeast.png';
import pourIcon from 'assets/micro-required-pour.png';
import './MicroRequiredIndicator.less';

const UNCHECKED_TOOLTIP = 'This beer doesn\'t require micro readings for quality control, '
  + 'which means it\'s a multi-cultured beer that is not safe to be poured on mono-culture lines.';

const CHECKED_TOOLTIP = 'This beer requires micro readings for quality control '
  + 'and can be poured on mono-culture lines.';

const MicroRequiredIndicator = ({ checked, onChange, disabled }) => {
  const isChecked = !!checked;
  const tooltip = isChecked ? CHECKED_TOOLTIP : UNCHECKED_TOOLTIP;
  const canToggle = typeof onChange === 'function' && !disabled;

  const icon = (
    <img
      className="micro-required-indicator__icon"
      src={isChecked ? pourIcon : yeastIcon}
      alt=""
    />
  );

  const trigger = canToggle ? (
    <button
      type="button"
      className="micro-required-indicator micro-required-indicator__button"
      aria-label={tooltip}
      onClick={(event) => {
        event.preventDefault();
        onChange(!isChecked);
      }}
    >
      {icon}
    </button>
  ) : (
    <span className="micro-required-indicator" aria-label={tooltip}>
      {icon}
    </span>
  );

  return (
    <Tooltip title={tooltip} trigger={['hover', 'click']}>
      {trigger}
    </Tooltip>
  );
};

MicroRequiredIndicator.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

MicroRequiredIndicator.defaultProps = {
  checked: false,
  onChange: undefined,
  disabled: false,
};

export default MicroRequiredIndicator;
